

export class LookupData {
  id: any;
  name: string;

  nameLoaded: boolean;

  public getDisplayText() {
    if (this.id !== undefined) {
      return this.id.toString() + ':' + this.name;
    } else {
      return '';
    }
  }

  constructor() {
    this.nameLoaded = false;
    this.id = null;
    this.name = '';
  }

  public copyFrom(obj: any) {
    this.id = obj.id;
    this.name = obj.name;

    if (this.name !== undefined && this.name !== '') {
      this.nameLoaded = true;
    } else {
      this.nameLoaded = false;
    }
  }
}


export interface AdvancedLookupComponent {
  getSelectedItem(): any;
}
